// src/components/TeamMemberCard.js
import React from 'react';
import styles from './Team.module.css';

function TeamMemberCard({ profile, isExpanded, onClick }) {
  return (
    <div className={styles.card} onClick={onClick}>
      <img src={profile.image} alt={profile.name} className={styles.image} />
      <h2 className={styles.name}>{profile.name}</h2>
      <p className={styles.title}>{profile.title}</p>
      {isExpanded && (
        <div className={styles.description}>
          <p>{profile.description}</p>
        </div>
      )}
    </div>
  );
}

export default TeamMemberCard;
